<section
    class="flex-column flex-start-start"
    style="height: auto"
>
    <div class="flex-row flex-start-center">
        <p class="page-header-title">{{ title }}</p>
        <ng-content select="[titleAdditions]"></ng-content>
    </div>
    @if (subtitle) {
    <p class="page-header-subtitle">
        {{ subtitle }}
    </p>
    } @if (backStrategy !== 'disabled') {
    <button
        mat-button
        class="back-button has-icon"
        (click)="backHandler()"
    >
        <mat-icon>keyboard_arrow_left</mat-icon>
        <span>Back</span>
    </button>
    }
</section>
